export const ADMIN_GENERAL_MANAGER = 1;
export const HSE_DEPARTMENT_MANAGER = 2;
export const HSE_MANAGER = 3;
export const APP_USER = 4;
export const GUEST_USER = 26;